export default "__VITE_ASSET__B0LQ6Cun__"